import { render, staticRenderFns } from "./PainelJornada2019.vue?vue&type=template&id=64b49a5e"
import script from "./PainelJornada2019.vue?vue&type=script&lang=js"
export * from "./PainelJornada2019.vue?vue&type=script&lang=js"
import style0 from "./PainelJornada2019.vue?vue&type=style&index=0&id=64b49a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports